module.exports = __webpack_public_path__ + "static/media/2-pile-of-coin.b8a24530.png";